import { MenuItem, Select } from "@mui/material";
import type { InvestorCommunicationCategory } from "../../api/types/investorCommunicationsTypes";

interface Props {
  categories: InvestorCommunicationCategory[];
  categoryExternalId: string | undefined;
  onChange: (categoryExternalId: string | undefined) => void;
  fullWidth?: boolean;
}

const allCategoriesValue = "";

const NewsCategorySelect = ({ categories, categoryExternalId, onChange, fullWidth }: Props) => (
  <Select
    displayEmpty
    inputProps={{ "aria-label": "News category" }}
    value={categoryExternalId ?? allCategoriesValue}
    onChange={(event) => onChange(event.target.value || undefined)}
    fullWidth={fullWidth}
    sx={fullWidth ? undefined : { width: "14rem" }}
  >
    <MenuItem value={allCategoriesValue}>All categories</MenuItem>
    {categories.map((category) => (
      <MenuItem key={category.externalId} value={category.externalId}>
        {category.name}
      </MenuItem>
    ))}
  </Select>
);

export default NewsCategorySelect;
